import React, {Component} from 'react'
import { defineMessages } from 'react-intl'
import { injectIntl } from 'react-intl'
import Icon from "../../common/icon/icon.component.jsx"

class MetadataListOfChoiceItemForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            value: '',
            index: 0,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteValue = this.deleteValue.bind(this)
        this.changeValue = this.changeValue.bind(this)
    }

    componentDidMount() {
        this.setState({
            value: this.props.value || '',
            index: this.props.index || 0
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value || '',
            index: nextProps.index || 0
        })
    }

    handleFormChange(event) {
        this.setState({
            value: event.target.value
        }, () => {
            this.changeValue()
        })
    }

    deleteValue(e) {
        e.preventDefault()
        const onDelete = this.props.onDelete || function() {}
        onDelete(this.state.index)
    }

    changeValue() {
        const onChange = this.props.onChange || function() {}
        onChange(this.state.index, this.state.value)
    }

    render() {
        const messages = defineMessages({
            "value_placeholder": {
                id: 'custom_field_definition.form.edit.metadata.list_of_choice.item_value_placeholder',
                defaultMessage: 'Possible value',
            },
        })
        return (
            <div className="row pt-2">
                <div className="col-11">
                    <input
                        value={this.state.value}
                        onChange={this.handleFormChange}
                        type="text"
                        className="form-control"
                        placeholder={this.props.intl.formatMessage(messages['value_placeholder'])}
                    />
                </div>
                <div className="col-1">
                    <button className="btn btn-danger btn-sm" onClick={this.deleteValue}>
                        <Icon value={"trash"}/>
                    </button>
                </div>
            </div>
        );
    }
}

export default injectIntl(MetadataListOfChoiceItemForm)


// WEBPACK FOOTER //
// ./src/custom-field/form/metadatalistofchoiceitem.component.jsx